module.exports = __webpack_public_path__ + "img/PVCPaving.71e85192.png";